import axios from 'axios'
import Cookie from 'js-cookie'

/*
  Chegg UI will ultimately provide a hook or some utility to encapsulate all of
  this to hydrate the Chegg UI Header props, so this is just a temporary util for
  getting the necessary data.

  The user interface was taken from
  https://bitbucket.cheggnet.com/projects/CUI/repos/chegg-ui/browse/packages/page-layout/src/Header/UserInterface.ts
  for documentation purposes, but we likely won't need it once Chegg UI exposes
  the necessary utils.
*/

export interface HeaderUser {
  user_id: number
  fname: string
  lname: string
  nickname: string
  email: string
  emailShow: string
  campus_id: number
  schoolId: null
  avatar: string
  avatar_small: string
  hasHomeworkHelpSubscription: null
  subscriptionCatalogId: null
  subscriptionType: string
  fb_id: string
  gender: string
  school_year: string
  phantomPassword: boolean
  uuid: string
  isHighSchoolUser: boolean
}

const AJAX = `/_ajax`
const JERICHO_CSRF_TOKEN_URL: string = `/global/init`
const JERICHO_HEADER_USER_URL: string = `/header/global/user`

export const getJerichoCsrfToken = (baseUrl: string) =>
  axios.get(`${baseUrl}${AJAX}${JERICHO_CSRF_TOKEN_URL}`, { withCredentials: true })

export const getJerichoHeaderUser = (baseUrl: string, token: string) => {
  const userCookie = Cookie.get('SU') || 'loggedOutUser'
  const body = `SU=${encodeURIComponent(userCookie)}&token=${encodeURIComponent(token)}`

  return axios.post(`${baseUrl}${AJAX}${JERICHO_HEADER_USER_URL}`, body, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  })
}

export default {
  getJerichoCsrfToken,
  getJerichoHeaderUser,
}



// WEBPACK FOOTER //
// ./src/utils/http-clients/jericho.ts